module.exports = __webpack_public_path__ + "img/注射.c236aaec.png";